import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";
import Chars from "../views/chars/Chars.vue";
import Episode from "../views/episodes/Episode.vue";
import Locations from "../views/locations/Locations.vue";
import Location from "../views/locations/Location.vue";

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  // {
  //   path: "/about",
  //   name: "about",
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () =>
  //     import(/* webpackChunkName: "about" */ "../views/AboutView.vue"),
  // },
  {
    path: "/r",
    name: "random",
    component: Chars,
  },
  {
    path: "/r/:id",
    name: "character",
    component: Chars,
    props: true
  },
  {
    path: "/e",
    name: "episodes",
    component: Episode
  },
  {
    path: "/e/:id",
    name: "episode",
    component: Episode,
    props: true
  },
  {
    path: "/locs",
    name: "locations",
    component: Locations
  },
  {
    path: "/locs/:p",
    name: "locationspaged",
    component: Locations,
    props: true
  },
  {
    path:"/l/:id",
    name: "location",
    component: Location,
    props: true
  },
  {
    path: "/new",
    name: "new",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/newone.vue"),
  },
  { path: '/:pathMatch(.*)*', name: 'NotFound', component: HomeView },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
